import styled from "styled-components/macro";

export const Wrapper = styled.div`
  position: relative;
  display: grid;
  gap: 1rem 1.75rem;

  @media (min-width: 768px) {
    grid-template-columns: 1fr max-content;
    align-items: center;

    h3 {
      padding: 0 0.5rem;
    }
  }

  .form-control {
    background: var(--clr-bg-3);
    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr auto;
    column-gap: 0.5rem;
    border-radius: 5px;
    padding: 0.5rem;

    input {
      border-color: transparent;
      outline-color: var(--clr-grey-10);
      letter-spacing: var(--spacing);
      color: var(--clr-heading-2);
      padding: 0.25rem 0.5rem;
      background-color: var(--clr-bg-3);
    }

    input::placeholder {
      color: var(--clr-grey-5);
      letter-spacing: var(--spacing);
    }

    button {
      border-radius: 5px;
      border-color: transparent;
      padding: 0.25rem 0.5rem;
      text-transform: capitalize;
      letter-spacing: var(--spacing);
      background: var(--clr-bg-2);
      color: var(--clr-heading-1);
      transition: var(--transition);
      cursor: pointer;
      &:hover {
        background: var(--clr-bg-1);
        color: var(--clr-heading-1);
      }
    }

    svg {
      color: var(--clr-heading-1);
    }

    input,
    button,
    svg {
      font-size: 1.3rem;
    }

    @media (max-width: 800px) {
      button,
      input,
      svg {
        font-size: 0.85rem;
      }
    }
  }

  h3 {
    margin-bottom: 0;
    color: var(--clr-heading-2);
    font-weight: 400;
  }
`;

export const ErrorWrapper = styled.article`
  position: absolute;
  width: 90vw;
  top: 0;
  left: 0;
  transform: translateY(-100%);
  text-transform: capitalize;
  p {
    color: red;
    letter-spacing: var(--spacing);
  }
`;
